import { useEffect } from 'react'
import { trackEvent } from './config'

/**
 * Books one impression per mount of the thing `props` describes, and none while `props` is
 * null. The props are compared by value, so a re-render with the same banner emits nothing
 * and a banner that changes its `prompt` books a second one.
 */
export function useImpression(event: string, props: Record<string, unknown> | null) {
  const key = props === null ? null : JSON.stringify(props)
  useEffect(() => {
    if (key === null) {
      return
    }
    trackEvent(event, JSON.parse(key) as Record<string, unknown>)
  }, [event, key])
}
